import Swiper, {Autoplay, Navigation, Pagination, Thumbs} from 'swiper';
import anime from "animejs";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";

function resizeActiveSlide(swiperImageGallery,effInterval=400,first = false) {
    let currentSlideIndex = swiperImageGallery.activeIndex;
    let i = 0;

    for(let slide of swiperImageGallery.slides){
        let slideImgContainer = slide.querySelector('.imageGallery__img');
        let slideTextContainer = slide.querySelector('.imageGallery__text');
        if(slideImgContainer){
            slideImgContainer.style.width = null;
        }
        if(slideTextContainer){
            anime({
                targets: slideTextContainer,
                opacity: 0,
                easing: "linear",
                duration: effInterval
            });
        }
        slide.classList.remove('swiper-slide-scale');
    }
    if(first){
        effInterval = 0;
    }
    setTimeout(function () {
        for(let slide of swiperImageGallery.slides){
            let slideImgContainer = slide.querySelector('.imageGallery__img');
            let slideTextContainer = slide.querySelector('.imageGallery__text');
            if(i === currentSlideIndex && slide.classList.contains('swiper-slide-active')){
                slide.classList.add('swiper-slide-scale');
                if(slideImgContainer){
                    let slideImg = slideImgContainer.querySelector('img');
                    if(slideImg){
                        if(slideImg.complete){
                            slideImgContainer.style.width = slideImg.width +"px";
                        }
                        slideImg.onload = function () {
                            if(slideImg.complete){
                                slideImgContainer.style.width = slideImg.width +"px";
                            }
                        };
                    }
                }
                if(slideTextContainer){
                    anime({
                        targets: slideTextContainer,
                        opacity: 1,
                        easing: "linear",
                        duration: effInterval
                    });
                }
            }
            i++;
        }
    },effInterval);
}

export function initImageGallery(query = document.querySelectorAll('.imageGallery')) {
    let loops = {
        xs: false,
        sm: false,
        md: false,
        lg: false
    };

    let defaultOptions = {
        autoplay_interval: 3000,
        eff_interval: 1000,
        slidesPerBreakpoint: {
            xs: 1.5,
            sm: 3,
            md: 4,
            lg: 4
        }
    };

    const reference = document.querySelector('.imageGalleryReference');


    for(const el of query){
        let options = {};

        if (el.getAttribute('data-options') !== "") {
            options = JSON.parse(el.getAttribute('data-options'));
        }

        options = {...defaultOptions,...options};
        let countSlides = el.querySelectorAll('.swiper-slide').length;

        if(countSlides >= options.slidesPerBreakpoint.lg){
            loops.lg = true;
        }

        if(countSlides >= options.slidesPerBreakpoint.md){
            loops.md = true;
        }

        if(countSlides >= options.slidesPerBreakpoint.sm){
            loops.sm = true;
        }

        if(countSlides >= options.slidesPerBreakpoint.xs){
            loops.xs = true;
        }

        Swiper.use([Autoplay,Navigation]);
        const swiperImageGallery = new Swiper(el, {
            speed: options.eff_interval,
            slideToClickedSlide: false,
            preventClicks: false,
            spaceBetween: 20,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            autoplay: {
                delay: options.autoplay_interval,
            },
            breakpoints: {
                0: {
                    loop: loops.xs,
                    slidesPerView: options.slidesPerBreakpoint.xs,
                    spaceBetween: 10,
                    centeredSlides: true
                },
                768: {
                    loop: loops.sm,
                    slidesPerView: options.slidesPerBreakpoint.sm,
                    centeredSlides: true
                },
                1250: {
                    loop: loops.md,
                    slidesPerView: options.slidesPerBreakpoint.md,
                    centeredSlides: false
                },
                1540: {
                    loop: loops.lg,
                    slidesPerView: options.slidesPerBreakpoint.lg
                }
            },
            on: {
                init: function() {
                    resizeActiveSlide(this,options.eff_interval,true);
                },
                slideChange: function () {
                    resizeActiveSlide(this,options.eff_interval);
                }
            },
        });
        if(options.autoplay_interval === 0){
            swiperImageGallery.autoplay.stop();
        }
        el.addEventListener('mouseover',function(){
            swiperImageGallery.autoplay.stop();
        });

        el.addEventListener('mouseleave',function(){
            swiperImageGallery.autoplay.start();
        });

    }



    if(!reference){
        //swiper full gallery
        Swiper.use([Thumbs, Navigation]);
        const galleryThumbs2 = new Swiper('.gallerySwiperThumbs', {
            slidesPerView: 7,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    spaceBetween: 5,
                },
                768: {
                    spaceBetween: 10,
                }
            }
        });

        const galleryImage2 = new Swiper('.gallerySwiperImage', {
            loop: true,
            slidesPerView: 1,
            preloadImages: true,
            thumbs: {
                swiper: galleryThumbs2,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }



}

export function initImageGalleryReference(query = document.querySelectorAll('.imageGalleryReference')) {

    let elCounter = 0;
    for(const el of query) {
        elCounter++;

        let addClass= 'gallerySwiper_' + elCounter;

        const gallerySwiper = el.querySelector('.gallerySwiper');
        if (!gallerySwiper) continue;

        gallerySwiper.classList.add(addClass);

        const initSwiperClass = '.' + addClass;
        const isListGallery = el.classList.contains('referencesListGallery');
        const slideCount = el.querySelectorAll('.swiper-slide').length;

        Swiper.use([Thumbs, Navigation]);

        const galleryImage2 = new Swiper(initSwiperClass +' >.gallerySwiperImage', {
            loop: slideCount > 1,
            slidesPerView: 1,
            preloadImages: true,
            allowTouchMove: slideCount > 1,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
        });

        // Für Listen-Galerien: Klick auf Slide führt zur Detailseite
        if (isListGallery) {
            const detailLink = el.dataset.link;

            el.addEventListener('click', function(e) {
                // Nicht zur Detailseite wenn auf Pfeil geklickt
                if (!e.target.closest('.swiper-button-next, .swiper-button-prev')) {
                    window.location.href = detailLink;
                }
            });

            el.style.cursor = 'pointer';
        }
    }

}

/**
 * Initialisiert die schlanken Listen-Galerien (ohne Thumbs, mit Pagination)
 * Wird für Kundenfahrzeuge-Übersicht verwendet
 */
export function initReferencesListSwiper(query = document.querySelectorAll('.referencesListGallery')) {
    // Nur initialisieren wenn tatsächlich Listen-Galerien vorhanden sind
    if (query.length === 0) return;

    Swiper.use([Navigation, Pagination]);

    for (const el of query) {
        const swiperContainer = el.querySelector('.listGallerySwiper');
        if (!swiperContainer) continue;

        const detailLink = el.dataset.link;
        const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            loop: slideCount > 1,
            allowTouchMove: slideCount > 1,
            navigation: {
                nextEl: swiperContainer.querySelector('.swiper-button-next'),
                prevEl: swiperContainer.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperContainer.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true,
            },
        });

        // Klick auf Slide führt zur Detailseite
        el.addEventListener('click', function(e) {
            // Nicht zur Detailseite wenn auf Pfeil, Pagination oder beim Swipen geklickt
            if (!e.target.closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination')) {
                window.location.href = detailLink;
            }
        });

        el.style.cursor = 'pointer';
    }
}